import React from 'react'
import { LifeBuoy, Mail } from 'lucide-react'
import { useLocale } from '../contexts/LocaleContext'
import TransitionBanner from '../components/TransitionBanner'
import Header from '../components/Header'
import Footer from '../components/Footer'

/**
 * Addresses rather than a form: a contact form that lands in a shared inbox is the
 * same thing with extra steps, and email lets someone attach their shift list.
 */
const ContactPage: React.FC = () => {
  const { t } = useLocale()

  const cards = [
    { icon: Mail, title: t('contact.email'), value: t('contact.emailValue') },
    { icon: LifeBuoy, title: t('contact.support'), value: t('contact.supportValue') },
  ]

  return (
    <div className="min-h-screen">
      <TransitionBanner />
      <Header />

      <main className="mx-auto max-w-[720px] px-5 py-14 sm:px-8 lg:py-20">
        <h1 className="font-display text-[32px] font-bold tracking-display sm:text-[38px]">
          {t('contact.title')}
        </h1>
        <p className="mt-3 text-[17px] leading-relaxed text-text-secondary">
          {t('contact.subtitle')}
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {cards.map((card) => (
            <a
              key={card.title}
              href={`mailto:${card.value}`}
              className="flex items-start gap-3 rounded-lg border border-border bg-surface-card p-5 shadow-card hover:border-border-strong"
            >
              <card.icon className="mt-0.5 h-5 w-5 shrink-0 text-clay-600" />
              <span>
                <span className="block font-semibold text-text-primary">{card.title}</span>
                <span className="block text-md text-text-secondary">{card.value}</span>
              </span>
            </a>
          ))}
        </div>

        <div className="mt-6 rounded-lg border border-border bg-surface-sunken p-5">
          <h2 className="font-display text-xl font-semibold">{t('contact.salesTitle')}</h2>
          <p className="mt-1.5 text-md leading-relaxed text-text-secondary">
            {t('contact.salesBody')}
          </p>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default ContactPage
